import nodeClient from "./node-client";

export const saveTransport = async (payload) => {
  const response = await nodeClient.post(
    "/service/private/v0/transport/save",
    payload
  );
  return response?.data;
};

export const getAllTransport = async () => {
  const response = await nodeClient.post(
    "/service/private/v0/transport/find/all"
  );
  return response?.data?.result;
};

export const searchTransportByShortCode = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/transport/search/by/short/code?${encodeURI(query)}`
  );
  return response?.data?.result;
};

export const searchTransportByName = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/transport/search/by/name?${encodeURI(query)}`
  );
  return response?.data?.result;
};
